module.exports = __webpack_public_path__ + "img/view-history@2x.620d27ab.png";